import { lazy } from "react";
import ProtectedRouteOrganization from "./ProtectedRouteOrganization";

const OrganizationLoginPage = lazy(() => import("../pages/organization/auth/OrganizationLoginPage"));
const OrganizationHomePage = lazy(() => import("../pages/organization/home/OrganizationHomePage"));
const OrganizationCampaignsPage = lazy(() => import("../pages/organization/campaigns/OrganizationCampaignsPage"));
const OrganizationDonationsPage = lazy(() => import("../pages/organization/donations/OrganizationDonationsPage"));
const OrganizationFinancialsPage = lazy(() => import("../pages/organization/financials/OrganizationFinancialsPage"));

export const organizationRoutes = [
    { path: "/organization/login", element: <OrganizationLoginPage /> },
    { path: "/organization", element: <ProtectedRouteOrganization><OrganizationHomePage /></ProtectedRouteOrganization> },
    { path: "/organization/campaigns", element: <ProtectedRouteOrganization><OrganizationCampaignsPage /></ProtectedRouteOrganization> },
    { path: "/organization/donations", element: <ProtectedRouteOrganization><OrganizationDonationsPage /></ProtectedRouteOrganization> },
    { path: "/organization/financials", element: <ProtectedRouteOrganization><OrganizationFinancialsPage /></ProtectedRouteOrganization> },
];
